<template>
  <modal @before-close="beforeClose" @before-open="beforeOpen" @opened="opened" name="scheduleDetail"
         :draggable="'.header'"
         :reset="true"
         :classes="['schedule','generalbox']" :adaptive="true"
         :height="500" :width="'80%'" :max-width="1540" :min-width="1092" :click-to-close="false">
    <div class="header">
      <h2>日程详情</h2>
      <div @click="close" class="close">
        <i class="iconfont icon-cha"></i>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="title">日程标题：<span class="xin">*</span></div>
        <div class="form">
          <input v-model="eventTitle" type="text"/>
        </div>
      </div>
      <div class="row">
        <div class="title">日程时间：<span class="xin">*</span></div>
        <div class="form datePicker">
          <flatPickr placeholder="请选择开始时间" :config="flatPickerConfig" v-model="schTime"></flatPickr>&nbsp;&nbsp;~
          <flatPickr placeholder="请选择结束时间" :config="flatPickerConfig" v-model="schTimeEnd"></flatPickr>
          <div class="drop">
            是否提醒：
            <multiselect v-model="needNotice"
                         :options="needNoticeOptions"
                         placeholder="请选择是否提醒"
                         :multiple="false"
                         label="title"
                         :show-labels="false"
                         :clear-on-select="false"
                         :close-on-select="true"
                         :allow-empty="false"
                         :taggable="true"></multiselect>
          </div>
          <div v-if="isShowCounter" class="counter">

            提醒次数：
            <counter @valueChange="valueChange" :initVal="noticeCount" :max="100" :min="0"></counter>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="drop">
          <div class="title">重要程度：<span class="xin">*</span></div>
          <div class="form datePicker">
            <multiselect v-model="currentImportantGrade"
                         :options="getImportanceGradeData"
                         placeholder="请选择重要程度"
                         :multiple="false"
                         label="title"
                         :show-labels="false"
                         :clear-on-select="false"
                         :close-on-select="true"
                         :allow-empty="false"
                         :taggable="true"></multiselect>
          </div>
        </div>
      </div>
      <div v-if="false" class="row">
        <div class="title">日程类型：<span class="xin">*</span></div>
        <div class="form">
          <multiselect v-model="selectType"
                       :options="typeList"
                       placeholder="请选择日程类别"
                       :multiple="false"
                       label="title"
                       :show-labels="false"
                       :clear-on-select="false"
                       :close-on-select="true"
                       :allow-empty="false"
                       :taggable="true"></multiselect>
        </div>
      </div>
      <div class="row">
        <div class="title">日程地点：<span class="xin">*</span></div>
        <div class="form">
          <input v-model="address" type="text"/>
        </div>
      </div>

      <div class="row">
        <div class="title">日程内容：<span class="xin">*</span></div>
        <div class="form">
          <textarea v-model="content" name="" id="" cols="30" rows="3"></textarea>
        </div>
      </div>


      <ul class="btnlist">
        <li @click="submit"><i class="iconfont icon-save"></i>保存</li>
        <li @click="close"><i class="iconfont icon-cha"></i>取消</li>
      </ul>
    </div>

  </modal>
</template>

<script>
  import multiselect from 'vue-multiselect';
  import counter from 'components/globalComp/counter';
  import flatPickr from 'vue-flatpickr-component';
  import {Mandarin} from 'flatpickr/dist/l10n/zh.js';
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  import Bus from 'common/js/bus.js';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';

  export default {
    name: "scheduleDetail",
    data() {
      return {
        schId: null,
        //---表单数据---
        schTime: null,
        schTimeEnd: null,
        eventTitle: null,
        address: null,
        content: null,
        //----end-----
        needNoticeOptions: [{
          title: "是",
          value: 1,
        }, {
          title: "否",
          value: 0,
        }
        ],
        currentImportantGrade: null,
        //类别数据
        typeList: [
          {
            title: "课程",
          },
          {
            title: "会议",
          },
          {
            title: "预约",
          },
          {
            title: "其他",
          }
        ],
        selectType: null,
        needNotice: {
          title: "否",
          value: 0,
        },
        noticeCount: 0,
        flatPickerConfig: {
          enableTime: true,
          dateFormat: "Y-m-d H:i",
          locale: Mandarin,
        },
        baseData: {},
      }
    },
    computed: {
      ...mapGetters(['getImportanceGradeData']),
      isShowCounter() {
        if (!this.needNotice) {
          return false;
        }
        if (this.needNotice.value) {
          return true;
        }
        return false;
      }
    },
    components: {multiselect, counter, flatPickr},
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("scheduleDetail");
      },
      submit() {
        //TODO:提交日程
        if (this.schId === 0) {
          this.createSchedule();
        } else {
          this.updateSchedule();
        }

      },
      //获取下拉选择器的项
      getSelectDateItem(val) {
        if (!val) {
          val = 0
        } else {
          val = 1
        }
        let targetItem = null;
        this.needNoticeOptions.forEach((item, index) => {
          if (item.value === val) {
            targetItem = item;
          }
        });
        return targetItem;
      },
      //modal hook
      async beforeOpen(data) {
        console.log("modal取到的数据：", data);
        if (data.params.id === 0) {
          this.schId = 0;
          this.schTime = data.params.currSelectDate + ' 09:00';
          this.schTimeEnd = data.params.currSelectDate + ' 18:00';
          this.eventTitle = null;
          this.needNotice = null;
          this.address = null;
          this.content = null;
          return;
        }

        let editData = data.params[0];
        this.schId = editData.id;

        let scheduleData = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getScheduleObj?id=' + this.schId)
        scheduleData = scheduleData.data.data[0]
        this.schTime = scheduleData.time;
        this.schTimeEnd = scheduleData.endtime;
        this.eventTitle = scheduleData.title;
        this.needNotice = this.getSelectDateItem(scheduleData.warn);
        this.noticeCount = scheduleData.warnNum;
        this.address = scheduleData.location;
        this.content = scheduleData.content;
      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      //beforeClose
      beforeClose() {
      },

      async createSchedule() {
        if (!this.eventTitle || !this.schTime || !this.content || !this.address || !this.currentImportantGrade) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '带*号为必填项，请确认填写完整！'
          })
          return
        }

        let res = await axios.post(apiConfig.REQUEST_URL + "/shall/front_addSchedule?" + this.$qs.stringify({
          title: this.eventTitle,
          content: this.content,
          time: this.schTime + ':00',
          endtime: this.schTimeEnd + ':00',
          sysId: 'ehall',
          sysName: '一站式微服务平台',
          location: this.address,
          warn: this.needNotice ? this.needNotice.value : null,
          warnNum: this.noticeCount,
          importance: this.currentImportantGrade.value,
          property: this.selectType ? this.selectType.title : null
        }));
        if (res.data.status) {
          this.$parent.refreshSchedule();
        }
        console.log(res)
        this.$notify({
          group: 'global',
          title: res.data.msg,
        });
        this.$modal.hide("scheduleDetail");
        Bus.$emit('refreshScheduleList', {time: this.schTime})
      },
      async updateSchedule() {
        if (!this.eventTitle || !this.schTime || !this.content || !this.address || !this.currentImportantGrade) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '带*号为必填项，请确认填写完整！'
          })
          return
        }

        let res = await axios.post(apiConfig.REQUEST_URL + "/shall/front_editSchedule?" + this.$qs.stringify({
          id: this.schId,
          title: this.eventTitle,
          content: this.content,
          time: this.schTime + ':00',
          endtime: this.schTimeEnd + ':00',
          location: this.address,
          warn: this.needNotice ? this.needNotice.value : null,
          warnNum: this.noticeCount,
          importance: this.currentImportantGrade.value,
          property: this.selectType ? this.selectType.title : null,
          sort: 0
        }));
        if (res.data.status) {
          this.$parent.refreshSchedule();
        }
        this.$notify({
          group: 'global',
          title: res.data.msg,
        });
        this.$modal.hide("scheduleDetail");
        Bus.$emit('refreshScheduleList', {time: this.schTime})
      },
      valueChange(ev) {
        this.noticeCount = ev.val;
      }
    },
    mounted() {

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .content
    padding 30px 20px

    .row
      margin-top 10px
      min-height 50px
      line-height 50px
      border-bottom 1px solid #eeeeee
      white-space nowrap

      &:last-of-type
        border-bottom none

      &::after
        content ""
        display block
        width 100%
        clear both

      & > div
        display block

      .title
        padding-left 10px
        width 100px
        float left
        font-size 14px
        color #666666

        .xin
          color #990000
          font-weight bold

      .form
        float left
        width calc(100% - 120px)

        input, textarea
          font-family '微软雅黑'
          outline none
          width 100%
          font-size 14px
          line-height 30px
          border-radius 15px
          padding 0 1em
          color #666666
          border 1px solid #cccccc

        &.datePicker
          font-size 14px
          color #666666

          & > input
            width 200px
            height 30px
            text-align center
            display inline-block

          & > div
            display inline-block
            margin-right 10px
            /*border 1px solid #cccccc*/
            min-width 100px

          & >>> .multiselect
            height 30px

          & >>> .counter
            display inline-block
            vertical-align middle

          & >>> .vdp-datepicker
            display inline-block

            input
              height 30px
              padding 0 1em
              border-radius 15px
              text-align center
              border 1px solid #cccccc

          .drop
            & >>> .multiselect
              width 160px !important

    .btnlist
      text-align center
      font-size 0
      margin-top 20px

      li
        margin 0 20px
        font-size 14px
        color #666666
        display inline-block
        border 1px solid #666666
        width 100px
        height 30px
        border-radius 15px
        cursor pointer
        transition 300ms
        user-select none

        &:hover
          background-color #eeeeee

        i
          vertical-align middle
          margin-right 5px
          line-height 30px

</style>



// WEBPACK FOOTER //
// src/components/schedule/scheduleDetailModal.vue